import React, { useState, useRef, useEffect } from 'react';
import { downloadChatPDF, sendEmail } from './chatHistoryUtils';
import { useSelector } from 'react-redux';
import { selectChatWithSessionId } from '../../slices/chatSlice';
import { EllipsisHorizontalIcon, ArrowDownTrayIcon, EnvelopeIcon, TrashIcon, Cog6ToothIcon } from '@heroicons/react/24/outline';

export default function EllipsisDropDown({ setConfirmDelete, sessionId, setIsChatConfigVisible }) {
  const [showDropdown, setShowDropdown] = useState(false);
  const dropdownRef = useRef(null);
  const chat = useSelector(selectChatWithSessionId(sessionId))

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowDropdown(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  return (
    <div ref={dropdownRef}>
      <EllipsisHorizontalIcon className="w-6 h-6 cursor-pointer text-white" onClick={() => setShowDropdown(!showDropdown)} />


    {
      showDropdown && (
        <div className="absolute right-0 mt-2 w-42 rounded-md shadow-xl z-20 bg-[#474747] custom-scrollbar">
          <ul className="text-gray-400">
            <li className="flex items-center space-x-4 text-white px-4 py-2 hover:scale-105 hover:text-shadow cursor-pointer" onClick={() => {
                downloadChatPDF(chat.messages);
                setShowDropdown(false);
              }}>
              <ArrowDownTrayIcon className='w-5 h-5'/> 
              <p className="text-sm">Download</p>
            </li>
            <li className="flex items-center space-x-4 text-white px-4 py-2 hover:scale-105 hover:text-shadow cursor-pointer" onClick={() => {
                sendEmail(chat.messages);
                setShowDropdown(false);
              }}>
              <EnvelopeIcon className='w-5 h-5' /> 
              <p className="text-sm">Send Email</p>
            </li>
            <li className="flex items-center space-x-4 text-white px-4 py-2 hover:scale-105 hover:text-shadow cursor-pointer" onClick={() => {
                setIsChatConfigVisible(true);
                setShowDropdown(false);
              }}>
              <Cog6ToothIcon className='w-5 h-5' /> 
              <p className="text-sm">Configure</p>
            </li>
            <li className="flex items-center space-x-4 text-red-500 px-4 py-2 hover:scale-105 hover:text-shadow cursor-pointer" onClick={() => {
                setConfirmDelete(true);
                setShowDropdown(false);
              }}>
              <TrashIcon className='w-5 h-5'/>
              <p className="text-sm">Delete</p>
            </li>
          </ul>
        </div> 
      )
    }


    </div>
  )
}
